import PropTypes from "prop-types";
import { nameToInitials } from "@circleco/ui-kit";
import { t } from "@/i18n-js/instance";
import { getCommunityLogoUrlAndType } from "@/react/helpers/communityHelpers";
import { useThemeContext } from "@/react/providers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";
import CircleLogo from "../../../../../assets/images/circular-logo@2x.png";

export const CommunityImage = ({
  community,
  withCircleBranding = false,
  isLeftAlignLogo = false,
}) => {
  const { isDarkAppearance } = useThemeContext();

  const { url, type } = community
    ? getCommunityLogoUrlAndType(community, isDarkAppearance)
    : {};

  const brandColor = community?.prefs?.brand_color;
  const color =
    (isDarkAppearance ? brandColor?.dark : brandColor?.light) || "#506cf0";

  if (!type || withCircleBranding) {
    return (
      <div className="h-12 w-12 md:h-16 md:w-16">
        <img loading="lazy" src={CircleLogo} alt={t("circle")} />
      </div>
    );
  }

  if (type === "icon" && !url) {
    return (
      <div className="flex flex-col items-center">
        <div
          className={classNames(
            "mb-3 flex h-12 w-12 items-center justify-center rounded-lg text-center",
            {
              "self-start": isLeftAlignLogo,
            },
          )}
          style={{ backgroundColor: color }}
          aria-hidden
        >
          <Typography.TitleSm weight="semibold" color="text-brand-button">
            {nameToInitials(community?.name)}
          </Typography.TitleSm>
        </div>
        <Typography.LabelMd weight="medium">
          {community?.name}
        </Typography.LabelMd>
      </div>
    );
  }

  if (type === "icon" && url) {
    return (
      <div className="flex flex-col items-center">
        <img
          loading="lazy"
          src={url}
          alt=""
          className={classNames("mb-3 h-8", {
            "self-start": isLeftAlignLogo,
          })}
        />
        <Typography.LabelMd weight="medium">
          {community?.name}
        </Typography.LabelMd>
      </div>
    );
  }

  return <img loading="lazy" className="h-6" src={url} alt={community?.name} />;
};

CommunityImage.propTypes = {
  community: PropTypes.object,
  withCircleBranding: PropTypes.bool,
  isLeftAlignLogo: PropTypes.bool,
};
